import { logout } from "../app/Login/logout";
import { getConfig } from "../config";

// Helper to safely get base URL at runtime
function getBaseUrl(): string {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3003";
  }
  try {
    const { AUTH_SERVICE_URL } = getConfig();
    return AUTH_SERVICE_URL;
  } catch (err) {
    console.error("Config not loaded yet", err);
    return ""; // fallback or throw error if preferred
  }
}

const originalFetch = window.fetch;

export class FetchError extends Error {
  constructor(
    public status: number,
    public message: string,
    public context?: any,
  ) {
    super(message);
  }
}

export const authFetch = async <T>(
  url: string,
  method: "GET" | "POST" | "PATCH" | "PUT" = "GET",
  body?: any,
  signal?: AbortSignal,
): Promise<T> => {
  const input = `${getBaseUrl()}${url}`;

  try {
    const response = await originalFetch(input, {
      method,
      headers: {
        "Content-Type": "application/json",
      },
      signal,
      body: body ? JSON.stringify(body) : undefined,
    });

    if (response.status === 401) {
      logout();
      throw new FetchError(401, "Unauthorized – Logging out.");
    }

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch {
        errorData = { message: "Failed to parse error response" };
      }

      throw new FetchError(response.status, `Failed to fetch ${method} @ ${url}`, errorData);
    }

    try {
      return (await response.json()) as T;
    } catch {
      throw new FetchError(response.status, `Invalid JSON response from ${url}`);
    }
  } catch (error) {
    console.log("error", error);
    if (error instanceof FetchError) {
      throw error;
    }
    throw new FetchError(0, `Network error while fetching ${method} @ ${url}`, error);
  }
};
